class PerfectAudienceAnalytics {
  clientSales(campaign) {
    this._trigger(campaign.pixels.campaign);

    if (this._globalPixelIsNotCampaignPixel(campaign)) {
      this._trigger(campaign.pixels.global);
    }
  }

  clientThankYou(order) {
    this._trigger(order.campaign.pixels.campaign);

    if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
      this._trigger(order.campaign.pixels.global);
    }
  }

  _globalPixelIsNotCampaignPixel(campaign) {
    return campaign.pixels.campaign.perfect !== campaign.pixels.global.perfect;
  }

  _trigger(pixels) {
    if (pixels.perfect) {
      window.dataLayer.push({ 'clientPerfectAudiencePixelId': pixels.perfect });
      window.dataLayer.push({ 'event': 'client-perfect-audience-tracking' });
    }
  }
}

export default new PerfectAudienceAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/perfect-audience.js